import axios from 'axios';
import config from '../config';
import apiEndpoint from './apiEndpoint';
import { toast } from 'sonner';

const toastStyle = {
  style: {
    padding: '1rem',
  },
};

const api = axios.create({
  baseURL: config.mySpaceApiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

let isShowAuthErrorAlert = false;

// 요청 인터셉터 설정 - 토큰이 있으면 헤더에 추가
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 응답 인터셉터 설정
api.interceptors.response.use(
  (response: any) => {
    isShowAuthErrorAlert = false;
    return response;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

export default {
  ...apiEndpoint,
  api,
};
